import * as angular from 'angular';
import * as d3 from 'd3';

import { severityLevels } from '../../common/constants';
import { ComponentDefinition } from '../../models';

class SeverityDisplayController implements angular.IComponentController {
    isLoading: boolean;
    levels: string[];

    readonly level: number;
    readonly textContent: string;
    readonly titleContent: string;

    static $inject = [
        '$element',
        '$translate',
        '$timeout'
    ];

    constructor(
        private _$element: angular.IAugmentedJQuery,
        private _$translate: angular.translate.ITranslateService,
        private _$timeout: angular.ITimeoutService
    ) {
        this.levels = severityLevels.map(d => d.value);
    }

    $onInit() {
        this._$timeout(() => this.refreshTitle());
    }

    $onChanges() {
        this._$timeout(() => this.refreshTitle());
    }

    private refreshTitle() {
        if (this.titleContent) {
            this.setTitle(this.titleContent);
        } else if (this.level) {
            const levelLabel = this._$translate.instant(this.levels[this.level]);
            this.setTitle(levelLabel);
        }
    }

    private setTitle(title: string): void {
        d3.select(this._$element[0])
            .select('title')
            .html(title);
    }
}

export const wtSeverityDisplay: ComponentDefinition = {
    componentId: 'wtSeverityDisplay',
    controller: SeverityDisplayController,
    controllerAs: 'vm',
    template: require('./severityDisplay.component.html'),
    bindings: {
        level: '<',
        textContent: '<?',
        titleContent: '<?'
    }
};
